class InfoCards extends HTMLElement {
  constructor() {
    super();
    this.version = +this.dataset.version || 1;
    this.swiperEl = this.querySelector(".swiper");
  }

  connectedCallback() {
    switch (this.version) {
      case 1:
        this.swiper = new Swiper(this.swiperEl, {
          slidesPerView: 1.2,
          spaceBetween: 12,
          centeredSlides: true,
          watchSlidesProgress: true,
          grabCursor: true,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
            sensitivity: 0.5,
          },
          pagination: {
            enabled: true,
            clickable: true,
            el: ".swiper-pagination",
          },
          breakpoints: {
            480: {
              slidesPerView: 1.5,
              centeredSlides: true,
            },
            768: {
              slidesPerView: 3,
              centeredSlides: false,
              pagination: { enabled: false },
            },
            1024: { centeredSlides: false, slidesPerView: 4, spaceBetween: 24 },
            1280: { centeredSlides: false, slidesPerView: 4, spaceBetween: 32 },
          },
          on: {
            setTranslate: (swiper) => {
              if (window.innerWidth >= 768) {
                swiper.slides.forEach((slide) => {
                  slide.style.transform = "";
                });
                return;
              }

              swiper.slides.forEach((slide) => {
                const progress = slide.progress;

                const maxRotation = 10;
                const maxTranslateY = window.innerWidth >= 480 ? 6 : 7;

                const rotate = progress * maxRotation;
                const translateY = Math.abs(progress) * -maxTranslateY;

                slide.style.transform = `translateY(${translateY}vw) rotate(${rotate}deg)`;
              });
            },
            setTransition: (swiper, transition) => {
              swiper.slides.forEach((slide) => {
                slide.style.transitionDuration = `${transition}ms`;
              });
            },
          },
        });
        break;
      case 2:
        this.swiper = new Swiper(this.swiperEl, {
          spaceBetween: 12,
          slidesPerView: 1.05,
          grabCursor: true,
          pagination: {
            enabled: true,
            clickable: true,
            el: ".swiper-pagination",
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          mousewheel: {
            enabled: true,
            forceToAxis: true,
            sensitivity: 0.5,
          },
          breakpoints: {
            480: {
              slidesPerView: 1.5,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 16,
            },
            1024: {
              slidesPerView: 3,
            },
          },
        });
        break;
    }
  }
}

customElements.define("info-cards", InfoCards);
